import { PATHS } from "@/lib/router";
import TargetSetupPage from "./pages/TargetSetupPage";
import TargetSetupOverviewPage from "./pages/TargetSetupOverviewPage";

export const targetSetupRoutes = [
  {
    path: PATHS.TARGET_SETUP,
    element: <TargetSetupPage />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: PATHS.TARGET_SETUP_OVERVIEW,
    element: <TargetSetupOverviewPage />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
];
